import { InputBirthdayValidity } from '@afterpaytouch/core'
import { RegisterOptions } from 'react-hook-form'

interface DobValidationArgs {
  validity?: InputBirthdayValidity
  minAgeMsg?: string
  maxAgeMsg?: string
  requiredMsg?: RegisterOptions['required']
}

export const useDobValidation = ({ validity, minAgeMsg, maxAgeMsg, requiredMsg }: DobValidationArgs): RegisterOptions['validate'] => {
  if (typeof validity === 'undefined') {
    return {}
  }

  return {
    [InputBirthdayValidity.InvalidDate]: () => {
      return validity !== InputBirthdayValidity.InvalidDate || ((requiredMsg as string) ?? '')
    },
    [InputBirthdayValidity.UnderAge]: () => {
      return validity !== InputBirthdayValidity.UnderAge || (minAgeMsg ?? '')
    },
    [InputBirthdayValidity.OverAge]: () => {
      return validity !== InputBirthdayValidity.OverAge || (maxAgeMsg ?? '')
    },
  }
}
